import * as React from 'react'

import { ArticleState } from '../../reducers/articles'

interface ArticleProps {
  article: ArticleState['key']['articles'][0]
  onClick: (id: number, categoryId?: number) => void
}

const Article: React.FC<ArticleProps> = ({ article, onClick }) => {
  const handleArticleClick = () => {
    onClick(article.id, article.categoryId)
  }
  const handleArticleKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onClick(article.id, article.categoryId)
    }
  }

  return (
    <li
      className="list-group-item"
      onClick={handleArticleClick}
      // To follow this rule we need to add the WCAG/handlers to a div within the <li> but this requires css changes
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
      role="link"
      tabIndex={0}
      onKeyDown={handleArticleKeyDown}
    >
      <span className="answers-popular-item-header">{article.text}</span>
    </li>
  )
}

export { Article }
